import styled from '@emotion/styled';
import { Trustpilot } from '../TrustSeals';

type StageWrapperProps = {
  isErrorPage?: boolean;
  $isThin?: boolean;
  $isModernStage?: boolean;
  $isCard?: boolean;
};

const Wrapper = styled.div<StageWrapperProps>`
  position: relative;
  display: flex;
  ${({ isErrorPage }) => isErrorPage && 'margin-top: -1rem'};
  z-index: 10;

  ${({ isErrorPage, $isThin, $isModernStage, $isCard, theme }) => {
    if ($isThin || $isCard) return '';
    return `
    height: ${isErrorPage ? '203px' : '350px'};
    padding: ${theme.spacing['50']};
    ${$isModernStage && 'margin-top: 1rem;'}
  `;
  }}
`;

const TrustpilotWidget = styled(Trustpilot)<{ $isModernStage?: boolean }>`
  position: absolute;
  bottom: -1.5rem;
  left: 50%;
  transform: translateX(-50%);
  ${({ $isModernStage }) => $isModernStage && 'bottom: -0.1rem;'}
`;

export { Wrapper, TrustpilotWidget };
